// import { useState } from 'react'
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Icon,  } from '@mui/material'
import * as React from 'react';
import {useState, useEffect} from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Box,
    Button,
    Typography
} from '@mui/material'
import {useNavigate} from "react-router-dom";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SmartToyIcon from '@mui/icons-material/SmartToy'; // AI Assistant icon
import AIAssistantDialog from '../AIAssistantDialog'; // AI Assistant Dialog component

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';



const CATEGORIES = {
    // "Wastewater Recovery": [
    //   "amo 1690",
    //   "biomembrane filtration",
    //   "dye desalination",
    //   "electrochemical nutrient removal",
    //   "glsd anaerobic digestion",
    //   "groundwater treatment",
    //   "hrcs",
    //   "magprex",
    //   "metab",
    //   "photothermal membrane cando_p",
    //   "peracetic acid disinfection",
    //   "suboxic asm",
    //   "supercritical sludge to gas",
    //   "swine wastewater treatment",
    //   "nf-dspm-de",
    //   "nf-dspm-de with bypass"
    // ]
}


export default function FlowsheetsListTable(props) {
    let navigate = useNavigate();
    const { theme } = props;
    const [sortKey, setSortKey] = useState("name")
    const [sortDirection, setSortDirection] = useState("ascending")
    const [tableRows, setTableRows] = useState([])
    const [category, setCategory] = useState("all")
    const [aiAssistantOpen, setAiAssistantOpen] = useState(false) // AI Assistant dialog state

    useEffect(() => {
        console.log("FlowsheetsListTable - props.rows received:", props.rows);
        console.log("FlowsheetsListTable - props.rows length:", props.rows?.length);
        // Always show all flowsheets in the simplified table
        setTableRows([...props.rows])
    }, [props.rows])

    const handleFlowsheetClick = (id, built, options) => {
        let hasOptions = false
        if (Object.keys(options).length > 1) hasOptions = true
        navigate("/flowsheet/" + id + "/config", {
            replace: true,
            state: {built: built, hasOptions: hasOptions}
        })
    }
    const styles = {
        listRow: {
            cursor: "pointer",
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
                background: theme?.table?.alternateRowBackground || '#F8FAFF',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(102, 126, 234, 0.15)',
            },
            '&:last-child td, &:last-child th': {border: 0}
        },
        listHeaderRow: {
            background: theme?.table?.headerBackground || '#F8FAFF',
            '& .MuiTableCell-head': {
                color: theme?.table?.headerColor || '#4A5568',
                fontWeight: 600,
                fontSize: '0.95rem',
                borderBottom: `2px solid ${theme?.table?.border || '#E2E8F0'}`
            }
        },
        categoryRow: {
            cursor: "pointer",
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
                background: 'linear-gradient(135deg, #E6EDFF 0%, #F0F4FF 100%)',
                transform: 'translateX(4px)',
                boxShadow: '0 2px 8px rgba(102, 126, 234, 0.1)',
            }
        },
        buttonPrimary: {
            background: `linear-gradient(135deg, ${theme?.button?.background || '#667eea'}, #764ba2)`,
            color: theme?.button?.text || '#FFFFFF',
            fontWeight: 600,
            borderRadius: 2,
            px: 3,
            py: 1,
            textTransform: 'none',
            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
            '&:hover': {
                background: `linear-gradient(135deg, ${theme?.button?.hover || '#5a6fd8'}, #6a4c93)`,
                boxShadow: '0 6px 16px rgba(102, 126, 234, 0.4)',
                transform: 'translateY(-1px)'
            }
        },
        buttonSecondary: {
            border: `2px solid ${theme?.button?.background || '#667eea'}`,
            color: theme?.button?.background || '#667eea',
            fontWeight: 600,
            borderRadius: 2,
            px: 3,
            py: 1,
            textTransform: 'none',
            '&:hover': {
                background: theme?.button?.background || '#667eea',
                color: theme?.button?.text || '#FFFFFF',
                boxShadow: '0 4px 12px rgba(102, 126, 234, 0.2)',
                transform: 'translateY(-1px)'
            }
        }
    }

    const formatLastRun = (time) => {
        try {
            if (time) {
                let full_date = new Date(parseFloat(time) * 1000)
                return full_date.toLocaleString().split(',')[0];
            }
            return time
        } catch (e) {
            return time
        }

    }

    const handleSort = (key) => {
        if (sortKey === key) {
            if (sortDirection === 'ascending') setSortDirection('descending')
            else if (sortDirection === 'descending') setSortDirection('ascending')
        } else {
            setSortKey(key)
            if (key === "name") setSortDirection('ascending')
            else setSortDirection('descending')
        }
    }

    const sortRows = (rows) => {
        if (sortKey) return (rows.sort(compare))
        else return rows

    }



    function compare(a, b) {
        if (a[sortKey] < b[sortKey]) {
            if (sortDirection === "ascending") return -1;
            else return 1;
        }
        if (a[sortKey] > b[sortKey]) {
            if (sortDirection === "ascending") return 1;
            else return -1;
        }
        return 0;
    }


    const handleAiAssistantClick = () => {
        setAiAssistantOpen(true);
        console.log("AI Assistant clicked - opening dialog");
    };

    return (
        <TableContainer sx={{
            p: 0,
            overflowX: 'auto',
            border: `2px solid ${theme?.card?.border || '#E2E8F0'}`,
            borderRadius: { xs: 1, sm: 2 },
            '&::-webkit-scrollbar': {
                height: { xs: '4px', sm: '6px' }
            },
            '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
                borderRadius: { xs: '2px', sm: '3px' }
            },
            '&::-webkit-scrollbar-thumb': {
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                borderRadius: { xs: '2px', sm: '3px' }
            }
        }}>
            <Table sx={{
                minWidth: { xs: 300, sm: 500, md: 700, lg: 800 },
                width: '100%',
                borderCollapse: 'separate',
                borderSpacing: 0
            }}>
                <TableHead sx={{
                    background: `linear-gradient(135deg, ${theme?.button?.background || '#667eea'}, #764ba2)`,
                    '& .MuiTableCell-head': {
                        color: '#FFFFFF',
                        fontWeight: 700,
                        fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                        borderBottom: 'none',
                        py: { xs: 1.5, sm: 2, md: 2.5 },
                        px: { xs: 1, sm: 2, md: 3 }
                    }
                }}>
                    <TableRow>
                        <TableCell sx={{ 
                            minWidth: { xs: 150, sm: 200, md: 300, lg: 400 },
                            width: '70%'
                        }}>
                            Flowsheet Name
                        </TableCell>
                        <TableCell sx={{ 
                            minWidth: { xs: 100, sm: 150, md: 200, lg: 250 },
                            width: '30%',
                            textAlign: 'center'
                        }}>
                            Last Run
                        </TableCell>
                    </TableRow>
                </TableHead>
                        <TableBody>
                    {tableRows.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={2} sx={{ textAlign: 'center', py: 4 }}>
                                <Typography variant="body1" color="text.secondary">
                                    No flowsheets available. Please check the backend connection.
                                </Typography>
                            </TableCell>
                        </TableRow>
                    ) : (
                        sortRows(tableRows).map((row, index) => (
                        <TableRow
                            key={row.name}
                            sx={{
                                cursor: "pointer",
                                transition: 'all 0.2s ease-in-out',
                                borderBottom: `1px solid ${theme?.card?.border || '#E2E8F0'}`,
                                '&:hover': {
                                    background: theme?.table?.alternateRowBackground || '#F8FAFF',
                                    transform: { xs: 'none', sm: 'translateX(2px)', md: 'translateX(4px)' },
                                    boxShadow: '0 2px 8px rgba(102, 126, 234, 0.1)',
                                },
                                '&:last-child': {
                                    borderBottom: 'none'
                                }
                            }}
                            onClick={() => handleFlowsheetClick(row.id_, row.built, row.build_options)}
                        >
                            <TableCell sx={{
                                color: theme?.text?.primary || '#1F2937',
                                fontWeight: 500,
                                py: { xs: 1.5, sm: 2, md: 2.5 },
                                px: { xs: 1, sm: 2, md: 3 },
                                minWidth: { xs: 150, sm: 200, md: 300, lg: 400 }
                            }}>
                                <Box sx={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    gap: { xs: 1, sm: 1.5, md: 2 }
                                }}>
                                    <Box sx={{ 
                                        width: { xs: 6, sm: 7, md: 8 }, 
                                        height: { xs: 6, sm: 7, md: 8 }, 
                                        borderRadius: '50%',
                                        background: row.custom 
                                            ? `linear-gradient(135deg, ${theme?.button?.background || '#667eea'}, #764ba2)`
                                            : theme?.status?.info || '#3B82F6',
                                        flexShrink: 0
                                    }} />
                                    <Typography sx={{
                                        fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                                        lineHeight: 1.4,
                                        fontWeight: 500,
                                        wordBreak: 'break-word',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: '-webkit-box',
                                        WebkitLineClamp: { xs: 2, sm: 1 },
                                        WebkitBoxOrient: 'vertical'
                                    }}>
                                        {row.description}
                                    </Typography>
                                </Box>
                            </TableCell>
                            <TableCell sx={{
                                color: theme?.text?.secondary || '#6B7280',
                                py: { xs: 1.5, sm: 2, md: 2.5 },
                                px: { xs: 1, sm: 2, md: 3 },
                                minWidth: { xs: 100, sm: 150, md: 200, lg: 250 },
                                textAlign: 'center'
                            }}>
                                <Typography sx={{
                                    fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.9rem' },
                                    fontWeight: 500,
                                    lineHeight: 1.3
                                }}>
                                    {formatLastRun(row.last_run)}
                                </Typography>
                            </TableCell>
                        </TableRow>
                        ))
                    )}
                        </TableBody>
                    </Table>
            
            {/* AI Assistant Dialog */}
            <AIAssistantDialog 
                open={aiAssistantOpen} 
                onClose={() => setAiAssistantOpen(false)} 
                flowsheetData={props.rows}
            />
        </TableContainer>
    );

}

